import { render, staticRenderFns } from "./edits.vue?vue&type=template&id=bb2efcc4"
import script from "./edits.vue?vue&type=script&lang=js"
export * from "./edits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports